import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SparklesIcon } from 'lucide-react';
export function MethodSection() {
  const letters = [{
    letter: 'R',
    word: 'Rutina'
  }, {
    letter: 'E',
    word: 'Entorno'
  }, {
    letter: 'P',
    word: 'Penumbra'
  }, {
    letter: 'O',
    word: 'Olfato'
  }, {
    letter: 'S',
    word: 'Sonido'
  }, {
    letter: 'O',
    word: 'Orden'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.8
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.4
      }
    }
  };
  return <section className="w-full bg-gradient-to-b from-terracotta-50 to-cream py-20 px-4" data-id="element-149">
      <div className="max-w-4xl mx-auto" data-id="element-150">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-151">
          <div className="flex justify-center gap-2 mb-6" data-id="element-152">
            <MoonIcon className="w-8 h-8 text-terracotta" data-id="element-153" />
            <SparklesIcon className="w-6 h-6 text-sage" data-id="element-154" />
          </div>

          <h2 className="font-heading text-3xl sm:text-4xl text-charcoal mb-4" data-id="element-155">
            El Método <span className="text-terracotta" data-id="element-156">R.E.P.O.S.O.</span>
          </h2>
          <p className="font-body text-warmGray text-lg max-w-2xl mx-auto" data-id="element-157">
            Un sistema basado en el Apego Nocturno Seguro que no es un
            "entrenamiento" de sueño frío y distante.
          </p>
        </motion.div>

        <motion.div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-12" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-158">
          {letters.map((item, index) => <motion.div key={index} className="flex items-center gap-2 bg-warmWhite rounded-full px-4 sm:px-6 py-3 shadow-warm border border-terracotta-100" variants={itemVariants} data-id="element-159">
              <span className="w-8 h-8 bg-terracotta rounded-full flex items-center justify-center text-white font-heading font-bold" data-id="element-160">
                {item.letter}
              </span>
              <span className="font-body font-medium text-charcoal" data-id="element-161">
                {item.word}
              </span>
            </motion.div>)}
        </motion.div>

        <motion.div className="bg-warmWhite rounded-3xl p-8 sm:p-10 shadow-warm border border-sage-100" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-162">
          <p className="font-body text-lg text-warmGray leading-relaxed text-center" data-id="element-163">
            En lugar de forzar al bebé,{' '}
            <span className="font-semibold text-charcoal" data-id="element-164">
              hackeamos su biología
            </span>{' '}
            para que su cerebro reciba señales de seguridad total. Al alinear el
            entorno con su ritmo circadiano, el sueño deja de ser una lucha y se
            convierte en un{' '}
            <span className="text-terracotta font-semibold" data-id="element-165">
              proceso natural
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}